import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import VipPurchase from './pages/VipPurchase';
import Team from './pages/Team';
import Dividend from './pages/Dividend';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<VipPurchase />} />
          <Route path="/vip" element={<VipPurchase />} />
          <Route path="/team" element={<Team />} />
          <Route path="/dividend" element={<Dividend />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
